import React, { useContext } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Step from "@material-ui/core/Step";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { FormContext } from "../util/context";
import { StepLabel } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import Gender from "./form/Gender";
import Category from "./form/Category";
import CategoryInfo from "./form/CategoryInfo";
import Exercise from "./form/Exercise";
import Alcohol from "./form/Alcohol";
import Tobacco from "./form/Tobacco";
import Cannabis from "./form/Cannabis";
import Drugs from "./form/Drugs";
import SleepRating from "./form/SleepRating";
import DailyRoutine from "./form/DailyRoutine";
import SleepPerNight from "./form/SleepPerNight";
import Neurodiversities from "./form/Neurodiversities";
import HeightandWeight from "./form/HeightandWeight";
import Concussions from "./form/Concussions";
import Dob from "./form/Dob";
import Name from "./form/Name";
import Stress from "./form/Stress";
import Anxiety from "./form/Anxiety";
import Irritability from "./form/Irritability";
import Energy from "./form/Energy";
import Submit from "./form/Submit";
import Intro from "./form/Intro";
import { MobileStepper } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  buttons: {
    alignContent: "center",
  },
}));

const StyledMobileStepper = withStyles({
  root: {
    maxWidth: "100%",
    justifyContent: "center",
  },
  progress: {
    width: "100%",
    flexGrow: 1,
    alignContent: "center",
  },
})(MobileStepper);

function getSteps() {
  return [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ];
}

function getStepContent(stepIndex) {
  switch (stepIndex) {
    case 0:
      return <Intro />;
    case 1:
      return <Gender />;
    case 2:
      return <Category />;
    case 3:
      return <CategoryInfo />;
    case 4:
      return <Exercise />;
    case 5:
      return <Cannabis />;
    case 6:
      return <Alcohol />;
    case 7:
      return <Tobacco />;
    case 8:
      return <Drugs />;
    case 9:
      return <Stress />;
    case 10:
      return <Anxiety />;
    case 11:
      return <Irritability />;
    case 12:
      return <Energy />;
    case 13:
      return <DailyRoutine />;
    case 14:
      return <SleepRating />;
    case 15:
      return <SleepPerNight />;
    case 16:
      return <Neurodiversities />;
    case 17:
      return <HeightandWeight />;
    case 18:
      return <Concussions />;
    case 19:
      return <Dob />;
    case 20:
      return <Name />;
    case 21:
      return <Submit />;

    default:
      return "Unknown stepIndex";
  }
}

export default function HorizontalLinearStepper() {
  const classes = useStyles();
  const [form, setForm] = useContext(FormContext);
  const steps = getSteps();

  // const handleNext = () => {
  //   setForm({ ...form, count: form.count + 1 });
  // };

  const handleBack = () => {
    setForm({ ...form, count: form.count - 1 });
  };

  const handleReset = () => {
    setForm({ ...form, count: 0 });
  };

  return (
    <div>
      <StyledMobileStepper
        variant="progress"
        steps={22}
        position="static"
        activeStep={form.count}
        className={classes.root}
      >
        {steps.map((label, index) => (
          <Step key={index}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </StyledMobileStepper>
      <div>
        {form.count === steps.length ? (
          <div>
            <Typography className={classes.instructions}>
              All steps completed
            </Typography>
            <Button onClick={handleReset}>Reset</Button>
          </div>
        ) : (
          <Grid container justifyContent="center">
            <div style={{ alignItems: "center" }}>
              <Typography className={classes.instructions}>
                {getStepContent(form.count)}
              </Typography>
              <div className={classes.buttons}>
                <Button
                  disabled={form.count === 0}
                  onClick={handleBack}
                  className={classes.backButton}
                  fullWidth
                  variant="outlined"
                >
                  Back
                </Button>
                {/* <Button
                  variant="contained"
                  color="primary"
                  onClick={handleNext}
                >
                  {form.count === steps.length - 1 ? "Finish" : "Next"}
                </Button> */}
              </div>
            </div>
          </Grid>
        )}
      </div>
    </div>
  );
}
